var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { radius, shadow } from '@mehilainen/mds-tokens';
import { Gray250Hex, WhiteHex } from '@mehilainen/mds-tokens/colors';
import { Box, styled } from '@mui/material';
import { shouldForwardProp } from '../mds-shared';
const customClasses = {
    outlined: 'mdsCardOutlined',
    elevated: 'mdsCardElevated',
    fullWidth: 'mdsCardFullWidth',
};
const cardStyleMap = {
    outlined: {
        borderRadius: radius[300].px,
        border: `1px solid ${Gray250Hex}`,
    },
    elevated: {
        borderRadius: radius[300].px,
        boxShadow: shadow['100'],
    },
    fullWidth: {
        boxShadow: 'none',
        borderRadius: '0',
    },
};
const cardHoverStyleMap = {
    outlined: {
        boxShadow: shadow['100'],
    },
    elevated: {
        boxShadow: 'none',
    },
    fullWidth: {},
};
const cardButtonStyleMap = {
    outlined: {},
    elevated: {
        border: 'none',
    },
    fullWidth: {
        border: 'none',
    },
};
const StyledCard = styled(
// NOTE: this is a ugly TS fix to extend Box props to include variant
(props) => _jsx(Box, Object.assign({}, props)), { shouldForwardProp })(({ $variant: $variant }) => (Object.assign(Object.assign({ backgroundColor: WhiteHex }, cardStyleMap[$variant]), { '&:is(a), &:is(button)': {
        cursor: 'pointer',
        '&:hover': cardHoverStyleMap[$variant],
    }, '&:is(button)': Object.assign({ textAlign: 'inherit', padding: '0', font: 'inherit' }, cardButtonStyleMap[$variant]) })));
/**
 * Card component for displaying content in a contained box with different styles
 *
 * @param component - Component to render (e.g. 'div', 'button', etc.)
 * @param children - Card content
 * @param sx - Custom styles using MUI's sx prop
 * @param variant - Component variant ('elevated', 'outlined', or 'fullWidth')
 *
 * @example
 * <Card variant="elevated">
 *   Content goes here
 * </Card>
 *
 * @example
 * <Card
 *   variant="outlined"
 *   component="button"
 *   onClick={() => handleClick()}
 * >
 *   Clickable card
 * </Card>
 */
export const Card = (props) => {
    const { component = 'div', children, variant = 'outlined', sx } = props, additionalProps = __rest(props, ["component", "children", "variant", "sx"]);
    return (_jsx(StyledCard, Object.assign({ className: customClasses[variant], component: component, "$variant": variant, sx: sx }, additionalProps, { children: children })));
};
